import { useExperiment, useExperimentCampaigns } from "@/http/api-hooks";
import { useSearchParams } from "react-router-dom";

// Hook to fetch experiment data for create/edit mode on /experiments/create
export function useExperimentData() {
  const [searchParams] = useSearchParams();
  const experimentIdParam = searchParams.get("id");
  const experimentId = experimentIdParam ? parseInt(experimentIdParam, 10) : null;

  const { data: currentExperiment, isLoading: experimentLoading } = useExperiment(experimentId);
  const { data: existingCampaigns, isLoading: campaignsLoading } = useExperimentCampaigns(experimentId);

  const isEditing = !!experimentId;
  const isDataReady = !experimentId || (currentExperiment !== undefined && !experimentLoading && !campaignsLoading);

  return {
    experimentId,
    isEditing,
    currentExperiment,
    existingCampaigns,
    isDataReady,
    experimentLoading,
  };
}
